import lesson1_1 from './chapter1/lesson1_1.js';
import lesson1_2 from './chapter1/lesson1_2.js';

import lesson2_1 from './chapter2/lesson2_1.js';
import lesson2_2 from './chapter2/lesson2_2.js';


const lessonRegistry = {
  '1-1': lesson1_1,
  '1-2': lesson1_2,

  '2-1': lesson2_1,
  '2-2': lesson2_2,
};


export const getContaPrimaraLesson = (
  unitId,
  lessonId
) => {
  const key =
    `${unitId}-${lessonId}`;

  return lessonRegistry[key] || null;
};


export default lessonRegistry;